import { assignWith, isArray } from 'lodash';

// eslint-disable-next-line @typescript-eslint/ban-types -- Vue types require Function
type Listeners = Record<string, Function | Function[]>;

export function mergeListeners(left: Listeners, right: Listeners): Listeners {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment -- TS limitation
  return assignWith({}, left, right, (a, b) => (a === undefined ? b : isArray(a) ? [...a, b] : [a, b]));
}
